import { render } from "./openBranch.vue?vue&type=template&id=bda43b0e"
import script from "./openBranch.vue?vue&type=script&lang=js"
export * from "./openBranch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__